import { get, post } from './http';

const medals = {
  // 获取等级列表
  getLevelList: (params) => {
    return get('/member/frontend/member/level/gets', params);
  },
  // 获取会员信息
  getMemberInfo: () => {
    return get('/member/frontend/member/info');
  },
  // 获取任务组分类id
  getMemberTaskCategoryId: (params) => {
    return get('/member/frontend/member/type/task/cids', params);
  },
  // 根据分类id获取任务
  getMemberTaskList: (params) => {
    return get('/task/frontend/activity/task-list', params);
  },
  // 获取会员等级权益
  getMemberBenefits: (params) => {
    return get('/member/frontend/member/benefits/gets', params);
  },
  // 装扮
  onDressup: (params) => {
    return post('/member/frontend/member/benefits/dress', params);
  },
  // 解锁权益
  unlockBenifit: (params) => {
    return post('/member/frontend/member/benefits/unlock', params);
  },
  // 分页查询成长值或创作记录列表
  getMemberGrowList: (params) => {
    return get('/member/frontend/member/value/record/page', params);
  },
  // 是否需要弹窗提示
  getLevelupStatus: (params) => {
    return get('/member/frontend/member/pop-up', params)
  },
  // 获取签到记录
  getCheckinList: (params) => {
    return get('/task/frontend/sign/record', params)
  },
  checkin: (params) => {
    return post('/task/frontend/sign/create')
  },
  getBestPick: (params) => {
    return get('/ugc/frontend/thread/bestPick', params)
  },
  // 是否内测用户
  queryIsBetaUser: (params) => {
    return get('/member/frontend/member/beta')
  },
  queryIsSignin: () => {
    return get('/task/frontend/sign/check/today')
  }
};
export default medals;
